/** 运营信息统一配置；联系方式与备案信息未配置时不展示。 */
const defaultAdminUrl = new URL('/', window.location.origin)
// 与管理端 Vite（80）及 compose（3000）的默认端口一致，保留当前主机和协议。
defaultAdminUrl.port = import.meta.env.DEV ? '' : '3000'
const adminUrl = import.meta.env.VITE_APP_ADMIN_URL || defaultAdminUrl.href
const adminEntryUrl = new URL(adminUrl, window.location.origin)
adminEntryUrl.pathname = adminEntryUrl.pathname.replace(/\/+$/, '') + '/auth/portal'
adminEntryUrl.search = new URLSearchParams({ portalOrigin: window.location.origin }).toString()
adminEntryUrl.hash = ''

export const siteConfig = {
  name: import.meta.env.VITE_APP_TITLE || '博白县职业中等专业学校汽车运用与维修示范专业资源库',
  company: import.meta.env.VITE_APP_COMPANY_NAME || '上海景格科技股份有限公司',
  email: import.meta.env.VITE_APP_CONTACT_EMAIL || '',
  phone: import.meta.env.VITE_APP_CONTACT_PHONE || '',
  icp: import.meta.env.VITE_APP_ICP_NUMBER || '',
  adminUrl,
  adminEntryUrl: adminEntryUrl.href,
}
